var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apps-search-not-found"},[_c('icon-search-not-found'),_vm._v(" "),_c('span',{staticClass:"apps-search-not-found__text"},[_vm._v(_vm._s(_vm.$t('apps.app.nothing_found')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }